/*
 * Journal behaviour (pt2 Screens 3 + 4). Progressive enhancement only —
 * every control works as a plain link/form without JS.
 *
 *  1. Load more — fetches the next paginated page and appends its grid
 *     cards in place (same pattern as the collection grid).
 *  2. Inline "Worn here" add-to-bag — AJAX add so she never leaves the
 *     article (the interactions spec's whole point). Confirms in place,
 *     updates the header bag count. The cart drawer opens here instead
 *     once the pt2 cart screen ships.
 *  3. Share — native share sheet on mobile, clipboard fallback.
 */

(function () {
  'use strict';

  // ---------------------------------------------------------- load more
  function wireLoadMore() {
    var btn = document.querySelector('[data-mjj-more]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.textContent = 'Loading…';
      fetch(btn.href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelectorAll('[data-mjj-list] .mjj-grid > *');
          var grid = document.querySelector('[data-mjj-list] .mjj-grid');
          incoming.forEach(function (card) { grid.appendChild(card); });

          var newPag = doc.querySelector('[data-mjj-pagination]');
          var pag = document.querySelector('[data-mjj-pagination]');
          if (newPag && pag) {
            pag.replaceWith(newPag);
            wireLoadMore();
          }
        })
        .catch(function () { window.location.href = btn.href; });
    });
  }

  // ------------------------------------------------- inline add-to-bag
  function wireInlineAdd() {
    document.querySelectorAll('[data-mja-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = form.querySelector('button');
        var original = button.textContent;
        button.disabled = true;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(form.querySelector('[name=id]').value), quantity: 1 }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return fetch('/cart.js').then(function (c) { return c.json(); });
          })
          .then(function (cart) {
            button.textContent = 'Added ✓';
            button.classList.add('is-added');
            document.querySelectorAll('[data-cart-count], .mj-header__count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            setTimeout(function () {
              button.textContent = original;
              button.classList.remove('is-added');
              button.disabled = false;
            }, 2500);
          })
          .catch(function () {
            button.disabled = false;
            form.submit();
          });
      });
    });
  }

  // --------------------------------------------------------------- share
  function wireShare() {
    document.querySelectorAll('[data-mja-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var payload = { title: btn.dataset.title || document.title, url: window.location.href };
        if (navigator.share) {
          navigator.share(payload).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(payload.url).then(function () {
            var original = btn.textContent;
            btn.textContent = 'Link copied';
            setTimeout(function () { btn.textContent = original; }, 2000);
          });
        }
      });
    });
  }

  function init() {
    wireLoadMore();
    wireInlineAdd();
    wireShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
